import G from './Getters';
import usePresentSelector from './usePresentSelector';
import { ANNOTATIONS } from './RecordTypes';
import AdjustableCropGridValue from './AdjustableCropGridValue';


export default function CropGridValueWrapper(props){
  let {
    width,
    value,
  } = props;

  let {annotationId} = value;

  let isAnnotationArchived = usePresentSelector(state => G.getMeta(state,{type:ANNOTATIONS,_id:value.annotationId}).archived)

  let inlineCrop = usePresentSelector(state => {
    return G.getCropFromAnnotation(state,value.annotationId)
  });

  if( isAnnotationArchived || !inlineCrop ){
    return <div style={{fontWeight:'bold',color:'red'}}>Image/crop not found.</div>;
  }


  return (
    <AdjustableCropGridValue 
      {...props}
      inlineCrop={inlineCrop}
      annotationId={annotationId}
      cellWidthOfCropBeingAdjusted={width}
    />
  )



}
